import React from "react";
import ContactContainer from "../Components/ContactComponents/ContactContainer";

export default function Contact() {
  return (
    <div id="contact" className="div-contact">
      <ContactContainer />
    </div>
  );
}
